import React from "react";
import PropTypes from "prop-types";
import styles from "./TextInput.module.css";

/**
 * Interactive component. A text input that has the option include additional text next to the label.
 */
export function TextInput({ label, placeholder, value, setValue }) {
  return (
    <div className={styles.container}>
      <input
        placeholder={placeholder}
        type="text"
        name={label}
        value={value}
        onChange={setValue}
        className={styles.input}
      />
    </div>
  );
}

TextInput.propTypes = {
  /**
   * The placeholder text of the input.
   */
  placeholder: PropTypes.string,
  /**
   * The value of the input.
   */
  value: PropTypes.string,
  /**
   * Function that fires onChange and sets the value of the input.
   */
  setValue: PropTypes.func,
};
